const slictionaryEmployees = 
    [
        "jackpitts@moneybutton.com",
        "johndifelice@moneybutton.com",
        "selflearningdictionary@moneybutton.com"
    ];

export {slictionaryEmployees}